import { observable, configure, action, computed } from 'mobx';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class TripletexStore {
    constructor() {

    }

    @action
    updateKeyValue(key, value) {
        this[key] = value;
    }

    @action
    updateObjectKeyValue(obj, key, value) {
        this[obj][key] = value;
    }

    @observable redirectUrl = null;
    @observable comparisonData = null;
    @observable comparisonLoading = false;
    @observable openPostsData = null;
    @observable openPostsLoading = false;
    @observable voucherPreview = null;
    @observable voucherPreviewLoading = false;
    @observable voucherHistory = [];
    @observable voucherHistoryLoading = false;
    @observable voucherPostLoading = false;
    @observable voucherPostResult = null;


    async getSessionToken() {
        const response = await util.fetchApi(`/api/integrations/tripletex/session-token/create`);
        switch (response.status) {
            case 200:
                // console.log('tripletexStore.getSessionToken', response);
                return response;
            default:
                console.error('tripletexStore.getSessionToken', response);
                return response;
        }
    }

    async getCustomers({ cellphone, email, name, orgNumber }) {
        const response = await util.fetchApi(`/api/integrations/tripletex/customers`, {
            method: 'GET',
        }, {
            cellphone,
            email,
            name,
            orgNumber,
        });
        switch (response.status) {
            case 200:
                // console.log('tripletexStore.getCustomers', response);
                return response;
            default:
                console.error('tripletexStore.getCustomers', response);
                return response;
        }
    }

    async getPaymentTypes() {
        const response = await util.fetchApi(`/api/integrations/tripletex/paymentTypes`);
        switch (response.status) {
            case 200:
                // console.log('tripletexStore.getPaymentTypes', response);
                return response;
            default:
                console.error('tripletexStore.getPaymentTypes', response);
                return response;
        }
    }

    async getProducts({ productNumber, count = 1000, customerPrefix = false } = {}) {
        const response = await util.fetchApi(`/api/integrations/tripletex/products`, {
            method: 'GET',
        }, {
            productNumber,
            count,
            customerPrefix: customerPrefix ? '1' : undefined,
        });
        switch (response.status) {
            case 200:
                return response;
            default:
                console.error('tripletexStore.getProducts', response);
                return response;
        }
    }

    async loadAllTripletexProducts() {
        // Load all products for this customer from Tripletex
        return this.getProducts({ count: 10000, customerPrefix: true });
    }

    async getInvoices() {
        const response = await util.fetchApi(`/api/integrations/tripletex/invoices`);
        switch (response.status) {
            case 200:
                // console.log('tripletexStore.getInvoices', response);
                return response;
            default:
                console.error('tripletexStore.getInvoices', response);
                return response;
        }
    }

    async updateInvoices(saleIds) {
        const response = await util.fetchApi(`/api/integrations/tripletex/invoices`, {
            method: 'PATCH'
        }, {
            saleIds,
        });
        switch (response.status) {
            case 202:
                // console.log('tripletexStore.updateInvoices', response);
                return response;
            default:
                console.error('tripletexStore.updateInvoices', response);
                return response;
        }
    }

    async updateInvoicesByDate(invoiceDateFrom, invoiceDateTo, dryRun = false) {
        const response = await util.fetchApi(`/api/integrations/tripletex/invoices/by-date?dryRun=${dryRun ? '1' : '0'}`, {
            method: 'PATCH'
        }, {
            invoiceDateFrom,
            invoiceDateTo
        });
        switch (response.status) {
            case 202:
                // console.log('tripletexStore.updateInvoicesByDate', response);
                return response;
            default:
                console.error('tripletexStore.updateInvoicesByDate', response);
                return response;
        }
    }

    async sendInvoiceToCustomer(saleId) {
        const response = await util.fetchApi(`/api/integrations/tripletex/invoices/${saleId}/send`, {
            method: 'POST',
        }, {});
        switch (response.status) {
            case 200:
                return response;
            default:
                console.error('tripletexStore.sendInvoiceToCustomer', response);
                return response;
        }
    }

    async createInvoice(saleId) {
        if (saleId) {
            const response = await util.fetchApi(`/api/integrations/tripletex/invoices/${saleId}`, {
                method: 'POST',
            }, {});
            switch (response.status) {
                case 200:
                    // console.log('fikenStore.getPaymentStatus', response);
                    return response;
                default:
                    console.error('tripletexStore.createInvoice', response);
                    return response;
            }
        }

        const response = await util.fetchApi(`/api/integrations/tripletex/invoices`, {
            method: 'POST'
        },{
            // "customer": {
            //   "id": 13158013
            // },
            "invoiceDate": "2024-09-30",
            "invoiceDueDate": "2024-10-15",
            // "dueDate": "2024-10-15",
            // "currency": "NOK",
            "orders": [
                {
                    "customer": {
                        "id": 13158013,
                        "name": "Raske Poter AS",
                    },
                    "orderDate": "2024-09-30",
                    "deliveryDate": "2024-09-30",

                    "orderLines": [
                        {
                            "description": "Consulting Services",
                            "count": 10,
                            "unitPriceExcludingVatCurrency": 1000,
                            "vatType": {
                                "percentage": 25,
                            }
                        }
                    ],

                },
            ],

            // "orderNumber": "INV-2024-0001",
            // "deliveryDate": "2024-09-29",
            // "kid": "123456789"
        });

        switch (response.status) {
            case 200:
                // console.log('tripletexStore.createInvoice', response);
                return response;
            default:
                console.error('tripletexStore.createInvoice', response);
                return response;
        }
    }

    async simulateInvoice(saleId) {
        if (!saleId) {
            return;
        }
        const response = await util.fetchApi(`/api/integrations/tripletex/invoices/${saleId}?simulate=true`, {
            method: 'POST',
        }, {});
        switch (response.status) {
            case 200:
                return response;
            default:
                console.error('tripletexStore.simulateInvoice', response);
                return response;
        }
    }

    // /invoice-payments/:sale
    async addPayment(saleId) {
        if (!saleId) {
            return;
        }
        const response = await util.fetchApi(`/api/integrations/tripletex/invoice-payments/${saleId}`, {
            method: 'PATCH',
        }, {});
        switch (response.status) {
            case 200:
                // console.log('tripletexStore.updateInvoicePayments', response);
                return response;
            default:
                console.error('tripletexStore.updateInvoicePayments', response);
                return response;
        }
    }

    async createCreditNote(saleId) {
        if (!saleId) {
            return;
        }
        const response = await util.fetchApi(`/api/integrations/tripletex/credit-notes/${saleId}`, {
            method: 'POST',
        }, {});
        switch (response.status) {
            case 200:
                // console.log('tripletexStore.createCreditNote', response);
                return response;
            default:
                console.error('tripletexStore.createCreditNote', response);
                return response;
        }
    }

    async closeOpenOrders({ dryRun = false, limit = 0 } = {}) {
        const params = [];
        if (dryRun) params.push('dryRun=1');
        if (limit > 0) params.push(`limit=${limit}`);
        const qs = params.length > 0 ? `?${params.join('&')}` : '';
        const response = await util.fetchApi(`/api/integrations/tripletex/close-open-orders${qs}`, {
            method: 'POST',
        }, {});
        switch (response.status) {
            case 200:
                return response;
            default:
                console.error('tripletexStore.closeOpenOrders', response);
                return response;
        }
    }

    async getInvoicesCompare({ dateFrom, dateTo } = {}) {
        this.updateKeyValue('comparisonLoading', true);
        const response = await util.fetchApi('/api/integrations/tripletex/invoices-compare', {
            method: 'GET',
        }, { dateFrom, dateTo });
        if (response.status === 200) {
            this.updateKeyValue('comparisonData', response.data);
        }
        this.updateKeyValue('comparisonLoading', false);
        return response;
    }

    @action clearComparisonData() {
        this.comparisonData = null;
        this.comparisonLoading = false;
    }

    async getOpenPosts({ dateFrom, dateTo } = {}) {
        this.updateKeyValue('openPostsLoading', true);
        const response = await util.fetchApi('/api/integrations/tripletex/open-posts', {
            method: 'GET',
        }, { dateFrom, dateTo });
        if (response.status === 200) {
            this.updateKeyValue('openPostsData', response.data);
        }
        this.updateKeyValue('openPostsLoading', false);
        return response;
    }

    @action clearOpenPostsData() {
        this.openPostsData = null;
        this.openPostsLoading = false;
    }

    async registerOpenPostPayment({ saleId, postingId, tripletexCustomerId }) {
        const response = await util.fetchApi('/api/integrations/tripletex/open-posts/register', {
            method: 'POST',
        }, { saleId, postingId, tripletexCustomerId });
        return response;
    }

    async createCustomer(data) {
        const response = await util.fetchApi(`/api/integrations/tripletex/customers`, {
            method: 'POST'
        },{
            "name": "Raske Poter AS",
            "postalAddress": {
                "addressLine1": "Kongens gate 1",
                "postalCode": "7011",
                "city": "Trondheim",
            },
            "email": "post@raskepoter.com",
            "phoneNumber": "12345678",
            "organizationNumber": "123456789",
            "customerNumber": "123456789",
            "accountManager": {
                "firstName": "Ola",
                "lastName": "Nordmann",
                "phoneNumberMobile": "12345678",
                "email": "test@test.com",
            },
        });

        switch (response.status) {
            case 200:
                // console.log('tripletexStore.createCustomer', response);
                return response;
            default:
                console.error('tripletexStore.createCustomer', response);
                return response;
        }
    }
    async getVoucherPreview({ startDate, endDate, excludeInvoice, excludeImported }) {
        this.updateKeyValue('voucherPreviewLoading', true);
        this.updateKeyValue('voucherPreview', null);
        const params = { startDate, endDate };
        if (excludeInvoice) {
            params.excludeInvoice = '1';
        }
        if (excludeImported) {
            params.excludeImported = '1';
        }
        const response = await util.fetchApi('/api/integrations/tripletex/voucher-preview', {
            method: 'GET',
        }, params);
        this.updateKeyValue('voucherPreviewLoading', false);
        switch (response.status) {
            case 200:
                this.updateKeyValue('voucherPreview', response.data);
                return response;
            default:
                console.error('tripletexStore.getVoucherPreview', response);
                return response;
        }
    }

    async postVoucher({ startDate, endDate, periodType, excludeInvoice, excludeImported }) {
        this.updateKeyValue('voucherPostLoading', true);
        this.updateKeyValue('voucherPostResult', null);
        const response = await util.fetchApi('/api/integrations/tripletex/vouchers', {
            method: 'POST',
        }, {
            startDate,
            endDate,
            periodType,
            excludeInvoice,
            excludeImported,
        });
        this.updateKeyValue('voucherPostLoading', false);
        switch (response.status) {
            case 201:
                this.updateKeyValue('voucherPostResult', response);
                this.getVoucherPreview({ startDate, endDate, excludeInvoice, excludeImported });
                this.getVoucherHistory();
                return response;
            default:
                console.error('tripletexStore.postVoucher', response);
                this.updateKeyValue('voucherPostResult', response);
                return response;
        }
    }

    async getVoucherHistory() {
        this.updateKeyValue('voucherHistoryLoading', true);
        const response = await util.fetchApi('/api/integrations/tripletex/vouchers');
        this.updateKeyValue('voucherHistoryLoading', false);
        switch (response.status) {
            case 200:
                this.updateKeyValue('voucherHistory', response.data || []);
                return response;
            default:
                console.error('tripletexStore.getVoucherHistory', response);
                return response;
        }
    }

    @action clearVoucherData() {
        this.updateKeyValue('voucherPreview', null);
        this.updateKeyValue('voucherPostResult', null);
    }
}

const store = new TripletexStore();
export default store;
